// Circular progress bar and accordion handler components

import { isElementInView, scrollSection } from './helpers';

// function adBubble() {
//   const adBanner = document.querySelector('.banner-bubble');
//   let currentScrollValue = '';
//   if (adBanner) {
//     setTimeout(() => {
//       adBanner.classList.add('show-banner');
//     }, 2000);

//     const bubbleTrigger = document.getElementById('open-bubble');
//     bubbleTrigger.addEventListener('click', () => {
//       document.querySelector('body').classList.add('banner-clicked');
//       currentScrollValue = window.pageYOffset || document.documentElement.scrollTop;
//       return currentScrollValue;
//     });

//     document.querySelector('.bubble-overlay').addEventListener('click', () => {
//       if (document.querySelector('body').classList.contains('banner-clicked')) {
//         document.querySelector('body').classList.remove('banner-clicked');
//       }
//     });
//     const closeBubbleIcon = document.getElementById('close-bubble');

//     closeBubbleIcon.addEventListener('click', () => {
//       if (document.querySelector('body').classList.contains('banner-clicked')) {
//         document.querySelector('body').classList.remove('banner-clicked');
//       }
//       adBanner.style.left = '-500px';
//     });
//   }

//   window.onscroll = function resetBubble() {
//     const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
//     if (scrollTop > currentScrollValue + 120) {
//       if (document.querySelector('body').classList.contains('banner-clicked')) {
//         document.querySelector('body').classList.remove('banner-clicked');
//       }
//     }
//   };
// }

function progressBar(loaderObj, pct, r) {
  // eslint-disable-next-line

  return (function progressBarinner() {
    let val = parseInt(pct, 10);
    const circle = loaderObj.querySelector('.svg>.bar');
    if (isNaN(val)) { // eslint-disable-line
      val = 100;
    } else {
      // const r = circle.getAttribute('r');
      const c = 2 * Math.PI * r;

      if (val < 0) {
        val = 0;
      }

      if (val > 100) {
        val = 100;
      }

      const dashOffset = (100 - val) / 100 * c;
      circle.style.strokeDashoffset = dashOffset;
    }
  }());
}

const loaderContainers = document.querySelectorAll('.loader-container');

function animateLoader() {
  if (loaderContainers) {
    loaderContainers.forEach((loader) => {
      const percentage = loader.getAttribute('data-pct');
      if (isElementInView(loader)) {
        if (loader.querySelector('.svg>.bar')) {
          const radius = loader.querySelector('.svg>.bar').getAttribute('r');
          setTimeout(() => { progressBar(loader, percentage, radius); }, 500);
        }
      }
    });
  }
}

export default function accordionHandler() {
  const accordion = document.querySelectorAll('.js-accordion');
  if (accordion) {
    accordion.forEach((accordionEl) => {
      const accordionToggle = accordionEl.querySelectorAll('.js-accordion-toggle');
      accordionToggle.forEach((el) => {
        el.addEventListener('click', () => {
          const targetItem = el.parentElement;
          const targetContent = targetItem.querySelector('.js-accordion-content');
          if (targetItem.classList.contains('open')) {
            targetItem.classList.remove('open');
            targetContent.style.maxHeight = null;
          } else {
            const accordionOpen = accordionEl.querySelector('li.open');
            if (accordionOpen) {
              accordionOpen.classList.remove('open');
              accordionOpen.querySelector('.js-accordion-content').style.maxHeight = null;
            }
            targetItem.classList.add('open');
            targetContent.style.maxHeight = `${targetContent.scrollHeight}px`;
          }
        });
      });
    });
  }
}

const scrollDownArrow = document.querySelector('.scroll-down-arrow');
if (scrollDownArrow) {
  const sectionId = scrollDownArrow.getAttribute('href');
  const headerHeight = document.querySelector('header').clientHeight;
  const elementTop = document.querySelector(sectionId).getBoundingClientRect().top;
  const scrollDistance = (elementTop - headerHeight) + 1;
  scrollDownArrow.addEventListener('click', (event) => {
    event.preventDefault();
    scrollSection(scrollDistance, 500);
  });
}

window.addEventListener('load', () => {
  accordionHandler();
  // adBubble();

  window.addEventListener('scroll', () => {
    animateLoader();
  });
});
